// extracted by mini-css-extract-plugin
export var dividerContainer = "_9z-0";
export var line = "_9z-1";